/**
 * 全局 Toast 视口组件：放置于 App 根，一次性渲染所有当前 toast。
 */

import { useToast } from "../hooks/useToast";

export function ToastViewport() {
  const { toasts, dismiss } = useToast();
  if (toasts.length === 0) return null;
  return (
    <div className="pointer-events-none fixed bottom-6 left-1/2 z-[110] flex -translate-x-1/2 flex-col items-center gap-2">
      {toasts.map((t) => (
        <button
          key={t.id}
          type="button"
          onClick={() => dismiss(t.id)}
          className={`leo-toast pointer-events-auto ${
            t.tone === "error"
              ? "border-semantic-danger/40 text-semantic-danger"
              : t.tone === "success"
                ? "border-semantic-success/40 text-semantic-success"
                : ""
          }`}
        >
          {t.message}
        </button>
      ))}
    </div>
  );
}